import Swal from "sweetalert2"
import { theme } from "./getSiteTheme"

function showAlert(message, confirmText = "Ok") {
  Swal.fire({
    iconHtml:
      theme === "kids"
        ? '<img loading="lazy" src="/img/popup_icons/success-icon--kids.svg" alt="success">'
        : '<img loading="lazy" src="/img/popup_icons/success-icon.svg" alt="success">',
    title: "Success!",
    text: message,
    confirmButtonText: confirmText,
    customClass: {
      container: "success",
    },
  })
}

function showError(message) {
  Swal.fire({
    iconHtml: '<img loading="lazy" src="/img/popup_icons/error-icon.svg" alt="error">',
    title: "Error",
    text: message,
    confirmButtonText: "Cancel",
    customClass: {
      container: "error",
    },
  })
}

function confirmAlert(message) {
  return new Swal({
    title: "Are you shure?",
    text: message,
    iconHtml: '<img loading="lazy" src="/img/popup_icons/warning-icon.svg" alt="warning">',
    showCancelButton: true,
    cancelButtonText: "Cancel",
    confirmButtonText: "Confirm",
    customClass: {
      container: "confirm",
    },
  })
}

function showToast(message) {
  return new Swal({
    toast: true,
    position: "bottom-left",
    title: message,
    showConfirmButton: false,
    timer: 1500,
    customClass: {
      container: "toast",
    },
  })
}

export { showAlert, showError, confirmAlert, showToast }
